export default __webpack_public_path__ + "static/char-v-42-40568b5d5c945732850c0409e520fd5e.webp";